/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* LAF_CLICK_ONLY_GLOBAL_START */
(function(){
  if(window.__lafClickOnlyGlobal)return;
  window.__lafClickOnlyGlobal=1;
  function desk(){return window.matchMedia&&window.matchMedia('(min-width:1025px)').matches}
  function items(){return Array.prototype.slice.call(document.querySelectorAll('.lf-header-luxury .lf-menu-item.has-dropdown'))}
  function close(){document.documentElement.removeAttribute('data-laf-click-menu');items().forEach(function(i){i.classList.remove('laf-dropdown-open')})}
  function openIndex(idx){document.documentElement.setAttribute('data-laf-click-menu',String(idx));items().forEach(function(i,n){i.classList.toggle('laf-dropdown-open',n===idx)})}
  document.addEventListener('mouseover',function(ev){
    if(!desk())return;
    var trigger=ev.target.closest&&ev.target.closest('.lf-header-luxury .lf-menu-item.has-dropdown>.lf-link');
    if(trigger){
      items().forEach(function(i){i.classList.remove('laf-dropdown-open')});
      document.documentElement.removeAttribute('data-laf-click-menu');
    }
  },true);
  document.addEventListener('pointerover',function(ev){
    if(!desk())return;
    var trigger=ev.target.closest&&ev.target.closest('.lf-header-luxury .lf-menu-item.has-dropdown>.lf-link');
    if(trigger){
      items().forEach(function(i){i.classList.remove('laf-dropdown-open')});
      document.documentElement.removeAttribute('data-laf-click-menu');
    }
  },true);
  document.addEventListener('click',function(ev){
    if(!desk())return;
    var trigger=ev.target.closest&&ev.target.closest('.lf-header-luxury .lf-menu-item.has-dropdown>.lf-link');
    if(trigger){
      ev.preventDefault();
      ev.stopPropagation();
      if(ev.stopImmediatePropagation)ev.stopImmediatePropagation();
      var idx=items().indexOf(trigger.closest('.lf-menu-item.has-dropdown'));
      if(idx<0)return;
      if(document.documentElement.getAttribute('data-laf-click-menu')===String(idx))close();else openIndex(idx);
      return;
    }
    if(ev.target.closest&&ev.target.closest('.lf-header-luxury .lf-dropdown a[href]'))return;
    if(!(ev.target.closest&&ev.target.closest('.lf-header-luxury')))close();
  },true);
  document.addEventListener('keydown',function(ev){if(ev.key==='Escape')close()},true);
})();
/* LAF_CLICK_ONLY_GLOBAL_END */

/* LAFFARTS_BLOG_LEAK_GUARD_JS_20260607_START */
;(function(){
  var forbidden=['Search'+'-Console','historische '+'Search','historische '+'Klicks','SEO '+'Upgrade 2026','Fotoeinschaetzung','Fotoeinschätzung'];
  function bad(t){return forbidden.some(function(x){return (t||'').indexOf(x)!==-1;});}
  function clean(){
    document.querySelectorAll('.laf-blog-upgrade__eyebrow').forEach(function(el){el.remove();});
    document.querySelectorAll('a,span,li,p').forEach(function(el){if(bad(el.textContent)){(el.closest('li')||el).remove();}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',clean);else clean();
  setTimeout(clean,200);setTimeout(clean,900);setTimeout(clean,1800);
})();
/* LAFFARTS_BLOG_LEAK_GUARD_JS_20260607_END */



/* LAFFARTS DRAWER MENU SINGLE RUNTIME 2026-07-15 */
(function () {
  var cameraSvg = '<span class="lf-camera-icon" aria-hidden="true"></span>';
  var reviews = [
    { name: 'Natali Dreven-Jakesevic', text: 'Sehr netter Kontakt. Meine Fragen wurden prompt beantwortet. Die Auftragsabwicklung verlief auch prompt und reibungslos. Die Vergoldung meines Eheringes ist einfach traumhaft schön geworden. Vielen lieben Dank an Herrn Laffarts.' },
    { name: 'Maxi Hochbaum', text: 'Die Vergoldung meines Ehering ist wunderschön geworden. Er ist wie neu! Danke für den tollen Service!' },
    { name: 'Ralf Mell', text: 'Tolle Arbeit. Kommunikation mit Herrn Laffart perfekt. Firma Laffarts uneingeschränkt zu empfehlen👍' },
    { name: 'V. F.', text: 'Top Arbeit sehr schnelle Lieferung' },
    { name: 'Richter Haymo', headline: 'Hervorragender Service und Qualität', text: 'Absolut empfehlenswert! Der Service war erstklassig, und der persönliche sowie gewissenhafte Kontakt hat mich begeistert. Die gelieferte Arbeit – eine Vergoldung mit Spezialoberfläche – war von höchster Qualität. Solch ein Unternehmen findet man nicht alle Tage. Vielen Dank für diese tolle Erfahrung!' },
    { name: 'Robin Kehrhahn', text: 'Meine Erwartungen wurden um ein vielfaches übertroffen. Ich bin sehr zufrieden und kann es nur weiter empfehlen.' },
    { name: 'S ELMO', text: 'Hat alles problemlos geklappt, sehr organisiert und vertrauenswürdig. Das Ergebnis gefällt mir sehr gut.' },
    { name: 'TheElementOfSurprise', text: 'Ich habe eine Ewigkeit nach jemandem gesucht, der meinen Ring vergolden kann. Laffarts hat sich meiner angenommen und trotz Komplikationen mit dem Material des Rings eine wunderschöne Vergoldung hingebracht. Es gab beim versenden sowie beim Annehmen keinerlei Probleme und ich bin super happy mit dem Ergebnis :))' },
    { name: 'Chrissi', headline: 'Ehering vergoldet', text: 'Ich bin absolut begeistert von der Vergoldung meines Rings! Das Ergebnis ist einfach fantastisch geworden – hochwertig, edel und mit viel Liebe zum Detail gearbeitet. Ehrlich gesagt sieht er sogar noch schöner aus, als ich es mir vorgestellt hatte. Mein Ring glänzt wieder wie neu und wirkt einfach wunderschön. Ich bin mehr als zufrieden und kann diesen Service nur weiterempfehlen. Vielen Dank für die tolle Arbeit!' },
    { name: 'Catharina Schilt', text: 'Wie immer super schön und hochwertige Arbeit! Bin sehr glücklich mit meinem vergoldeten Anhänger.' },
    { name: 'Linda Bräutigam', text: 'Liebes Team Laffarts, ich bin völlig aus dem Häuschen. Habe selten so einem tollen Dienstleister gesehen. Von der Anfrage bis hin zum Versand war alles 1a. Ich würde mich immer wieder für Laffarts entscheiden. Ihr habt mir so ein erfülltes Herz geschenkt, danke.' },
    { name: 'Patrick Lietz', text: 'Sehr gute Kommunikation über den Ablauf und perfekte Meister-Arbeit der Ware!!!' },
    { name: 'Lothar Sluzalek', text: 'Einfach nur schön 🤩' },
    { name: 'Christin Daniela', text: 'Ich kann Laffarts absolut von Herzen empfehlen. Der Service ist wirklich außergewöhnlich freundlich, herzlich und zuverlässig. Ich habe mich von Anfang bis Ende und darüber hinaus sehr gut aufgehoben gefühlt. Ich habe ein Schmuckstück mit großem sentimentalen Wert vergolden lassen und war von der Umsetzung und der besonders schönen Optik wirklich begeistert. Vor allem muss man sagen, dass es sich um ein komplizierteres Stück handelte und hier wirklich großartiges Handwerk bewiesen wurde. Sehr sorgfältig und geduldig. Lieben Dank für die tolle Arbeit und den großartigen Service. Das Preis-Leistungsverhältnis ist absolut gerechtfertigt.' },
    { name: 'Claudia Bleeck', text: 'Herzlichen Dank für den hervorragenden Service und freundlichen Kontakt. Sehr gute Arbeit.' },
    { name: 'Hanna Knüvener', text: 'Vielen Dank! Die Kette ist super schön geworden! Alles lief unkompliziert und reibungslos ab! :) Kann ich nur empfehlen!' },
    { name: 'marco sopora', text: 'Als ich den Ring damals gekauft habe, wow. Die Freude währte aber nicht lange. Also eingeschickt und heute zurück bekommen. Besser geht’s nicht, bin vom Ergebnis mehr als begeistert. 🤩' },
    { name: 'Alexandra Herbers', text: 'Bin happy und werde morgen die 3 Vergoldung in Auftrag geben 😊' },
    { name: 'Anna Denkler', text: 'Top Service von Anfang an, habe meinen Ring vergolden lassen und er ist wunderschön geworden. Man wurde über jeden Schritt benachrichtigt und die Bearbeitungszeit war mega schnell. Was will man mehr. Vielen lieben Dank liebes Laffarts Team' },
    { name: 'Sofi Schoeter', text: 'Erwartungen übermäßig übertroffen! Super schnell in der Abwicklung und Produktion. Und dann noch wunderschön verpackt zurück gekommen. Bin sehr begeistert.' }
  ];

  function isEnglish() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 || location.pathname.indexOf('/en') === 0;
  }

  function setCameraIcon() {
    document.querySelectorAll('.cart-trigger, label[for="lf-cart-check"]:not(.lf-cart-overlay):not(.close-cart)').forEach(function (trigger) {
      trigger.classList.add('lf-photo-trigger');
      if (trigger.getAttribute('data-camera-version') !== '20260716e') {
        trigger.innerHTML = cameraSvg + '<span class="cart-count" hidden>0</span>';
        trigger.setAttribute('data-camera-version', '20260716e');
      }
      trigger.setAttribute('aria-label', isEnglish() ? 'Open photo request' : 'Fotoanfrage öffnen');
      trigger.setAttribute('title', isEnglish() ? 'Photo request' : 'Fotoanfrage');
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function reviewMarkup() {
    return reviews.map(function (review, index) {
      var isLong = ((review.headline || '') + review.text).length > 175;
      var textId = 'laf-review-text-' + index;
      var toggle = isLong ? '<button type="button" class="laf-review-toggle" aria-expanded="false" aria-controls="' + textId + '">' + (isEnglish() ? 'Show full review' : 'Mehr anzeigen') + '</button>' : '';
      var headline = review.headline ? '<p class="laf-drawer-review-headline">' + escapeHtml(review.headline) + '</p>' : '';
      return '<article class="laf-drawer-review' + (isLong ? ' is-collapsed' : '') + '" aria-label="' + (isEnglish() ? 'Google review by ' : 'Google-Bewertung von ') + escapeHtml(review.name) + '"><div class="laf-drawer-stars" aria-hidden="true">★★★★★</div>' + headline + '<p class="laf-drawer-review-text" id="' + textId + '">„' + escapeHtml(review.text) + '“</p>' + toggle + '<p class="laf-drawer-review-author">' + escapeHtml(review.name) + '</p></article>';
    }).join('');
  }

  function drawerMarkup() {
    if (isEnglish()) {
      return '<span class="lf-cart-eyebrow">REQUEST · QUOTE · SHIPPING · RETURN</span>' +
        '<strong>One photo. One clear next step.</strong>' +
        '<p class="lf-cart-lead">Show us your piece. We assess what is possible and which gold finish fits its material and use.</p>' +
        '<ul class="lf-cart-checks">' +
          '<li><b>Start by photo, without sending it in</b><span>Receive an initial assessment before your piece travels.</span></li>' +
          '<li><b>The right process for your piece</b><span>Selected for its material, use and desired finish.</span></li>' +
          '<li><b>Jewellery, automotive, art and bespoke pieces</b><span>One entry point for exceptional objects and small series.</span></li>' +
          '<li><b>Guided safely through to its return</b><span>Insured shipping and one dedicated point of contact.</span></li>' +
        '</ul>' +
        '<div class="lf-cart-actions"><a href="/pages/kostenvoranschlag" class="lf-cart-primary">SEND PHOTO <span aria-hidden="true">→</span></a><a href="tel:043212045196" class="lf-cart-secondary">CLARIFY BY PHONE</a></div>' +
        '<section class="laf-drawer-reviews" aria-label="Google reviews"><div class="laf-drawer-reviews-title"><span>GOOGLE REVIEWS</span><span>TRUSTED BY 2,500+ CUSTOMERS</span></div><div class="laf-drawer-review-track" tabindex="0">' + reviewMarkup() + '</div><div class="laf-drawer-review-nav"><button type="button" class="laf-review-prev" aria-label="Previous review">←</button><span class="laf-review-progress" aria-hidden="true"><span></span></span><button type="button" class="laf-review-next" aria-label="Next review">→</button></div></section>';
    }
    return '<span class="lf-cart-eyebrow">ANFRAGE · ANGEBOT · VERSAND · ZURÜCK</span>' +
      '<strong>Ein Foto. Ein klarer nächster Schritt.</strong>' +
      '<p class="lf-cart-lead">Zeigen Sie Ihr Stück. Wir prüfen, was möglich ist und welche Goldoberfläche zu Material und Nutzung passt.</p>' +
      '<ul class="lf-cart-checks">' +
        '<li><b>Per Foto starten, ohne Einsenden</b><span>Erste Einschätzung, bevor Ihr Stück auf die Reise geht.</span></li>' +
        '<li><b>Das passende Verfahren für Ihr Stück</b><span>Ausgewählt nach Material, Nutzung und gewünschtem Finish.</span></li>' +
        '<li><b>Schmuck, Automotive, Kunst und Sonderstücke</b><span>Ein Zugang für besondere Einzelstücke und kleine Serien.</span></li>' +
        '<li><b>Sicher begleitet bis zur Rückkehr</b><span>Wertversand und ein fester Kontakt für die gesamte Abwicklung.</span></li>' +
      '</ul>' +
      '<div class="lf-cart-actions"><a href="/pages/kostenvoranschlag" class="lf-cart-primary">FOTO SENDEN <span aria-hidden="true">→</span></a><a href="tel:043212045196" class="lf-cart-secondary">TELEFONISCH KLÄREN</a></div>' +
      '<section class="laf-drawer-reviews" aria-label="Google-Bewertungen"><div class="laf-drawer-reviews-title"><span>GOOGLE-BEWERTUNGEN</span><span>ÜBER 2.500 ZUFRIEDENE KUNDEN</span></div><div class="laf-drawer-review-track" tabindex="0">' + reviewMarkup() + '</div><div class="laf-drawer-review-nav"><button type="button" class="laf-review-prev" aria-label="Vorherige Bewertung">←</button><span class="laf-review-progress" aria-hidden="true"><span></span></span><button type="button" class="laf-review-next" aria-label="Nächste Bewertung">→</button></div></section>';
  }


  function initReviewSlider(scope) {
    (scope || document).querySelectorAll('.laf-drawer-reviews').forEach(function (section) {
      var track = section.querySelector('.laf-drawer-review-track');
      var cards = Array.prototype.slice.call(section.querySelectorAll('.laf-drawer-review'));
      var previous = section.querySelector('.laf-review-prev');
      var next = section.querySelector('.laf-review-next');
      var progress = section.querySelector('.laf-review-progress > span');
      if (!track || !cards.length || !previous || !next || !progress) return;
      if (section.dataset.sliderReady === 'true') return;

      var index = 0;
      var frame = 0;
      var total = cards.length;

      function setState(nextIndex) {
        index = Math.max(0, Math.min(total - 1, nextIndex));
        cards.forEach(function (card, cardIndex) {
          card.setAttribute('aria-hidden', cardIndex === index ? 'false' : 'true');
          card.dataset.active = cardIndex === index ? 'true' : 'false';
        });
        progress.style.width = (((index + 1) / total) * 100) + '%';
      }

      function nearestIndex() {
        var left = track.scrollLeft;
        var closest = 0;
        var distance = Infinity;
        cards.forEach(function (card, cardIndex) {
          var currentDistance = Math.abs(card.offsetLeft - track.offsetLeft - left);
          if (currentDistance < distance) {
            closest = cardIndex;
            distance = currentDistance;
          }
        });
        return closest;
      }

      function updateFromScroll() {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(function () {
          setState(nearestIndex());
        });
      }

      function goTo(nextIndex, behavior) {
        var target = (nextIndex + total) % total;
        setState(target);
        track.scrollTo({
          left: cards[target].offsetLeft - track.offsetLeft,
          behavior: behavior || 'smooth'
        });
      }

      previous.addEventListener('click', function () { goTo(index - 1); });
      next.addEventListener('click', function () { goTo(index + 1); });
      section.addEventListener('click', function (event) {
        var toggle = event.target.closest && event.target.closest('.laf-review-toggle');
        if (!toggle) return;
        var card = toggle.closest('.laf-drawer-review');
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        toggle.textContent = expanded ? (isEnglish() ? 'Show full review' : 'Mehr anzeigen') : (isEnglish() ? 'Show less' : 'Weniger anzeigen');
        if (card) card.classList.toggle('is-expanded', !expanded);
      });
      track.addEventListener('scroll', updateFromScroll, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
      });
      window.addEventListener('resize', function () { goTo(index, 'auto'); }, { passive: true });

      section.dataset.sliderReady = 'true';
      setState(0);
      track.scrollLeft = 0;
    });
  }

  function renderDrawer() {
    setCameraIcon();
    var drawer = document.querySelector('.lf-cart-drawer, #mini-cart');
    if (!drawer) return;
    var title = drawer.querySelector('.cart-header h3, .drawer__title');
    if (title) title.textContent = isEnglish() ? 'PHOTO REQUEST' : 'FOTOANFRAGE';
    drawer.querySelectorAll('.loading-state, .cart-body, #lf-upsell-wrapper, .cart-footer, .lfd-card').forEach(function (node) {
      node.hidden = true;
    });
    var conversion = drawer.querySelector('.lf-cart-conversion');
    if (!conversion) {
      conversion = document.createElement('div');
      conversion.className = 'lf-cart-conversion';
      var header = drawer.querySelector('.cart-header, .drawer__header');
      if (header) header.insertAdjacentElement('afterend', conversion);
      else drawer.appendChild(conversion);
    }
    if (conversion.dataset.lafVersion !== 'review-slider-exact-20260716') {
      conversion.innerHTML = drawerMarkup();
      conversion.dataset.lafVersion = 'review-slider-exact-20260716';
    }
    initReviewSlider(conversion);
  }

  function polishMenu() {
    var menu = document.querySelector('.lf-mobile-drawer');
    if (!menu) return;
    var title = menu.querySelector('.drawer-title');
    var eyebrow = menu.querySelector('.lf-mobile-intro > span');
    var heading = menu.querySelector('.lf-mobile-intro > strong');
    var copy = menu.querySelector('.lf-mobile-intro > p');
    if (title) title.textContent = isEnglish() ? 'MENU' : 'MENÜ';
    if (eyebrow) eyebrow.textContent = isEnglish() ? 'OBJECTS IN GOLD' : 'OBJEKTWELTEN IN GOLD';
    if (heading) heading.textContent = isEnglish() ? 'What would you like to have gilded?' : 'Was möchten Sie vergolden lassen?';
    if (copy) copy.textContent = isEnglish() ? 'Choose the right category or start with one photo.' : 'Direkt zum passenden Bereich oder mit einem Foto starten.';
  }

  function boot() {
    setCameraIcon();
    renderDrawer();
    polishMenu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
  [120, 500, 1400].forEach(function (delay) { window.setTimeout(setCameraIcon, delay); });
  var cameraObserver = new MutationObserver(function () { window.requestAnimationFrame(setCameraIcon); });
  cameraObserver.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.cart-trigger')) {
      renderDrawer();
      window.setTimeout(renderDrawer, 80);
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'lf-cart-check' && event.target.checked) renderDrawer();
    if (event.target && event.target.id === 'lf-mobile-check' && event.target.checked) polishMenu();
  });
})();
/* /LAFFARTS DRAWER MENU SINGLE RUNTIME 2026-07-15 */

/* LAFFARTS MENU LAYER HOTFIX 2026-07-15 */
(function () {
  if (window.__lafMenuLayerHotfix) return;
  window.__lafMenuLayerHotfix = true;

  function ensureMenuStyle() {
    if (document.getElementById('laf-menu-layer-hotfix-style')) return;
    var style = document.createElement('style');
    style.id = 'laf-menu-layer-hotfix-style';
    style.textContent = [
      '@media(max-width:740px){',
      'body.laf-menu-open{overflow:hidden!important;touch-action:none!important}',
      'body.laf-menu-open .lf-header-luxury{display:none!important}body.laf-menu-open .lf-header-inner,body.laf-menu-open .lf-col-left,body.laf-menu-open .lf-mobile-toggle{visibility:hidden!important;pointer-events:none!important;z-index:0!important}',
      'body.laf-menu-open .lf-brand-center,body.laf-menu-open .lf-nav-right,body.laf-menu-open .laf-hsr,body.laf-menu-open .laf-header-service-register,body.laf-menu-open .laf-category-register,body.laf-menu-open .header-service-register{visibility:hidden!important;pointer-events:none!important}',
      'body.laf-menu-open .lf-mobile-overlay{display:block!important;position:fixed!important;inset:0!important;width:100vw!important;height:100dvh!important;margin:0!important;z-index:2147483644!important;background:rgba(8,8,8,.52)!important;backdrop-filter:blur(5px)!important}',
      'body.laf-menu-open .lf-mobile-drawer{display:flex!important;position:fixed!important;inset:0 auto 0 0!important;width:min(92vw,420px)!important;max-width:92vw!important;height:100dvh!important;max-height:100dvh!important;margin:0!important;transform:none!important;visibility:visible!important;opacity:1!important;z-index:2147483646!important;flex-direction:column!important;overflow:hidden!important;background:#fff!important;box-shadow:18px 0 50px rgba(0,0,0,.18)!important}',
      'body.laf-menu-open .lf-mobile-drawer .drawer-header{position:relative!important;flex:0 0 62px!important;height:62px!important;min-height:62px!important;padding:0 22px!important;display:flex!important;align-items:center!important;justify-content:space-between!important;border-bottom:1px solid #e8e2da!important;background:#fff!important}',
      'body.laf-menu-open .lf-mobile-drawer .drawer-title{font-family:Arial,sans-serif!important;font-size:10px!important;line-height:1!important;font-weight:800!important;letter-spacing:.2em!important;text-transform:uppercase!important;color:#a97816!important}',
      'body.laf-menu-open .lf-mobile-drawer .drawer-close{width:38px!important;height:38px!important;display:grid!important;place-items:center!important;border:1px solid #e1dbd2!important;background:#fff!important;font:300 21px/1 Arial,sans-serif!important;color:#111!important}',
      'body.laf-menu-open .lf-mobile-drawer .drawer-scroll-area{flex:1 1 auto!important;min-height:0!important;width:100%!important;height:auto!important;padding:0 22px 24px!important;overflow-y:auto!important;overflow-x:hidden!important;overscroll-behavior:contain!important;background:#fff!important}',
      'body.laf-menu-open .lf-mobile-intro{padding:24px 0 20px!important;border-bottom:1px solid #e8e2da!important}',
      'body.laf-menu-open .lf-mobile-intro span{display:block!important;font-family:Arial,sans-serif!important;font-size:9.5px!important;line-height:1!important;font-weight:800!important;letter-spacing:.17em!important;text-transform:uppercase!important;color:#a97816!important}',
      'body.laf-menu-open .lf-mobile-intro strong{display:block!important;max-width:12ch!important;margin:10px 0 0!important;font-family:Georgia,serif!important;font-size:34px!important;line-height:.96!important;font-weight:400!important;letter-spacing:0!important;color:#111!important}',
      'body.laf-menu-open .lf-mobile-intro p{max-width:33ch!important;margin:11px 0 0!important;font-family:Arial,sans-serif!important;font-size:13.5px!important;line-height:1.42!important;font-weight:400!important;color:#625d56!important}',
      'body.laf-menu-open .lf-mobile-quick{display:grid!important;grid-template-columns:1fr 1fr!important;width:100%!important;margin:18px 0!important;border-top:1px solid #e8e2da!important;border-left:1px solid #e8e2da!important}',
      'body.laf-menu-open .lf-mobile-quick a{min-height:48px!important;padding:10px 12px!important;display:flex!important;align-items:center!important;border-right:1px solid #e8e2da!important;border-bottom:1px solid #e8e2da!important;font-family:Arial,sans-serif!important;font-size:12px!important;line-height:1.2!important;font-weight:700!important;letter-spacing:0!important;text-transform:none!important;color:#111!important;text-decoration:none!important;background:#fff!important}',
      'body.laf-menu-open .lf-mobile-list{gap:0!important;margin:0!important;padding:0!important}',
      'body.laf-menu-open .mobile-entry{border-bottom:1px solid #e8e2da!important}',
      'body.laf-menu-open .mobile-link-wrapper{min-height:54px!important}',
      'body.laf-menu-open .mobile-main-link{font-family:Arial,sans-serif!important;font-size:12.5px!important;line-height:1.2!important;font-weight:700!important;letter-spacing:.04em!important;color:#111!important}',
      'body.laf-menu-open .lf-mobile-cta{margin:18px 0 0!important;padding:16px!important;border:1px solid #e3ddd4!important;background:#fbfaf7!important;box-shadow:none!important}',
      'body.laf-menu-open .lf-mobile-cta span{font-family:Arial,sans-serif!important;font-size:9.5px!important;line-height:1!important;font-weight:800!important;letter-spacing:.16em!important;color:#a97816!important}',
      'body.laf-menu-open .lf-mobile-cta p{margin:9px 0 12px!important;font-family:Arial,sans-serif!important;font-size:12.5px!important;line-height:1.4!important;color:#625d56!important}',
      'body.laf-menu-open .lf-mobile-cta-main,body.laf-menu-open .lf-mobile-cta-phone{height:44px!important;min-height:44px!important;margin:0!important;display:flex!important;align-items:center!important;justify-content:center!important;font-family:Arial,sans-serif!important;font-size:11px!important;line-height:1!important;font-weight:800!important;letter-spacing:.07em!important;text-transform:uppercase!important;text-decoration:none!important}',
      'body.laf-menu-open .lf-mobile-cta-main{background:#050505!important;color:#fff!important}',
      'body.laf-menu-open .lf-mobile-cta-phone{margin-top:8px!important;border:1px solid #ddd7ce!important;background:#fff!important;color:#111!important}',
      'body.laf-menu-open .lf-mobile-cta-partner,body.laf-menu-open .bottom-links{display:none!important}',
      '}',
      '@media(max-width:390px){body.laf-menu-open .lf-mobile-drawer .drawer-scroll-area{padding-left:18px!important;padding-right:18px!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function menuCheckbox() {
    return document.getElementById('lf-mobile-check');
  }

  function syncMenuState() {
    ensureMenuStyle();
    var checkbox = menuCheckbox();
    var isOpen = Boolean(checkbox && checkbox.checked);
    var drawer = document.querySelector('.lf-mobile-drawer');
    var overlay = document.querySelector('.lf-mobile-overlay');
    var hiddenLayers = document.querySelectorAll(
      '.lf-header-luxury, .laf-hsr, .laf-header-service-register, .laf-category-register, .header-service-register'
    );
    document.body.classList.toggle('laf-menu-open', isOpen);
    if (!drawer) return;

    if (isOpen) {
      if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      hiddenLayers.forEach(function (element) {
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });
      if (overlay) {
        overlay.style.setProperty('display', 'block', 'important');
        overlay.style.setProperty('position', 'fixed', 'important');
        overlay.style.setProperty('inset', '0', 'important');
        overlay.style.setProperty('width', '100vw', 'important');
        overlay.style.setProperty('height', '100dvh', 'important');
        overlay.style.setProperty('z-index', '2147483644', 'important');
      }
      drawer.style.setProperty('display', 'flex', 'important');
      drawer.style.setProperty('position', 'fixed', 'important');
      drawer.style.setProperty('top', '0', 'important');
      drawer.style.setProperty('right', 'auto', 'important');
      drawer.style.setProperty('bottom', '0', 'important');
      drawer.style.setProperty('left', '0', 'important');
      drawer.style.setProperty('width', 'min(92vw, 420px)', 'important');
      drawer.style.setProperty('max-width', '92vw', 'important');
      drawer.style.setProperty('height', '100dvh', 'important');
      drawer.style.setProperty('max-height', '100dvh', 'important');
      drawer.style.setProperty('margin', '0', 'important');
      drawer.style.setProperty('transform', 'none', 'important');
      drawer.style.setProperty('visibility', 'visible', 'important');
      drawer.style.setProperty('opacity', '1', 'important');
      drawer.style.setProperty('z-index', '2147483646', 'important');
      drawer.style.setProperty('flex-direction', 'column', 'important');
      drawer.style.setProperty('overflow', 'hidden', 'important');
    } else {
      drawer.style.setProperty('display', 'none', 'important');
      drawer.style.setProperty('visibility', 'hidden', 'important');
      if (overlay) overlay.style.setProperty('display', 'none', 'important');
      hiddenLayers.forEach(function (element) {
        element.style.removeProperty('display');
        element.style.removeProperty('visibility');
        element.style.removeProperty('pointer-events');
      });
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'lf-mobile-check') syncMenuState();
  }, true);
  document.addEventListener('click', function () {
    window.requestAnimationFrame(syncMenuState);
  }, true);
  window.addEventListener('pageshow', syncMenuState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureMenuStyle();
      syncMenuState();
    }, { once: true });
  } else {
    ensureMenuStyle();
    syncMenuState();
  }
})();
/* /LAFFARTS MENU LAYER HOTFIX 2026-07-15 */
